export default "__VITE_ASSET__$hhaBb68__"